exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dzu-inputLabel::before{display:none}.success-message{max-width:\"554px\"}.no-border{border:none}.bp-text-color{color:#6a4344}.field-gap-20{margin-bottom:20px}.field-gap-30{margin-bottom:30px}.dropzone-error-margin{margin-top:5px !important}.deposit-minimum{font-size:13px}.submit-button-flex{display:flex;gap:4px;align-items:center}#buyers-premium-wrapper input[type=text],#buyers-premium-wrapper input[type=number],#buyers-premium-wrapper select,#buyers-premium-wrapper textarea{font-size:16px}", ""]);

// exports
